module.exports = __webpack_public_path__ + "static/media/Untitled1_001.72d3ae4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/Untitled1_001.jpg
// module id = 1386
// module chunks = 1